'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdLocalFlorist = function MdLocalFlorist(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 9.1c-2.3 0-4.1 2-4.1 4.3s1.8 4.1 4.1 4.1 4.1-1.9 4.1-4.1-1.8-4.3-4.1-4.3z m-10.7 8c0-1.6 1-3 2.4-3.7-1.4-0.7-2.4-2.1-2.4-3.8 0-2.3 2-4.2 4.2-4.2 0.9 0 1.7 0.3 2.4 0.8v-0.3c0-2.3 1.8-4.3 4.1-4.3s4.1 2 4.1 4.3v0.3c0.7-0.5 1.5-0.8 2.4-0.8 2.2 0 4.2 1.9 4.2 4.2 0 1.7-1 3.1-2.4 3.8 1.4 0.7 2.4 2.1 2.4 3.7 0 2.3-2 4.2-4.2 4.2-0.9 0-1.7-0.3-2.4-0.8v0.4c0 2.2-1.8 4.1-4.1 4.1s-4.1-1.9-4.1-4.1v-0.4c-0.7 0.5-1.5 0.8-2.4 0.8-2.3 0-4.2-1.9-4.2-4.2z m10.7 19.5c-8.3 0-15-6.7-15-15 8.3 0 15 6.8 15 15z m0 0c0-8.2 6.7-15 15-15 0 8.3-6.7 15-15 15z' })
        )
    );
};

exports.default = MdLocalFlorist;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/local-florist.js
// module id = 3254
// module chunks = 0